
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-green-600 to-green-700">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Sobre FútbolCanchas
            </h1>
            <p className="text-xl md:text-2xl opacity-90 leading-relaxed">
              Conectamos a los amantes del fútbol con las mejores canchas de todo México
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                  Nuestra Misión
                </h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  En FútbolCanchas creemos que el fútbol es más que un deporte, es una pasión que une comunidades. 
                  Nuestra misión es facilitar el acceso a canchas de calidad para que cada partido sea una experiencia inolvidable.
                </p>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  Desde 2020, hemos ayudado a miles de equipos y jugadores a encontrar el espacio perfecto para 
                  entrenar, competir y disfrutar del deporte que más aman.
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-football-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-bold text-2xl text-green-600">500+</div>
                      <div className="text-gray-600">Canchas Registradas</div>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-group-line text-red-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-bold text-2xl text-red-600">10,000+</div>
                      <div className="text-gray-600">Usuarios Activos</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=group%20of%20diverse%20soccer%20players%20celebrating%20on%20a%20green%20football%20field%2C%20team%20spirit%2C%20happy%20athletes%2C%20modern%20sports%20facility%20with%20red%20and%20white%20details%2C%20community%20football&width=600&height=400&seq=aboutmission&orientation=landscape" 
                  alt="Nuestra misión" 
                  className="w-full h-auto rounded-lg shadow-lg object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              Nuestros Valores
            </h2>
            <p className="text-lg text-gray-600">
              Los principios que guían cada decisión en FútbolCanchas
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Confianza</h3>
              <p className="text-gray-600">
                Verificamos cada cancha para garantizar que cumpla con nuestros estándares de calidad y seguridad.
              </p>
            </div>
            
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-red-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Pasión</h3>
              <p className="text-gray-600">
                Compartimos tu amor por el fútbol y trabajamos para hacer de cada partido una experiencia especial.
              </p>
            </div>
            
            <div className="text-center p-6 bg-white rounded-lg shadow-md">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-community-line text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Comunidad</h3>
              <p className="text-gray-600">
                Fomentamos conexiones entre jugadores, equipos y propietarios de canchas en todo México.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              Nuestro Equipo
            </h2>
            <p className="text-lg text-gray-600">
              Conoce a las personas que hacen posible FútbolCanchas
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20hispanic%20male%20entrepreneur%2C%20confident%20business%20leader%2C%20clean%20white%20background%2C%20modern%20professional%20headshot%2C%20friendly%20smile&width=300&height=300&seq=team1&orientation=squarish" 
                alt="Carlos Mendoza" 
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover object-top"
              />
              <h3 className="text-xl font-bold text-gray-800 mb-2">Carlos Mendoza</h3>
              <p className="text-green-600 font-medium mb-2">CEO & Fundador</p>
              <p className="text-gray-600 text-sm">
                Ex-futbolista profesional con más de 15 años de experiencia en el deporte.
              </p>
            </div>
            
            <div className="text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20latina%20woman%20tech%20expert%2C%20software%20developer%2C%20clean%20white%20background%2C%20modern%20professional%20headshot%2C%20confident%20expression&width=300&height=300&seq=team2&orientation=squarish" 
                alt="María González" 
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover object-top"
              />
              <h3 className="text-xl font-bold text-gray-800 mb-2">María González</h3>
              <p className="text-red-600 font-medium mb-2">CTO</p>
              <p className="text-gray-600 text-sm">
                Ingeniera en sistemas especializada en plataformas deportivas y aplicaciones móviles.
              </p>
            </div>
            
            <div className="text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20hispanic%20male%20marketing%20manager%2C%20business%20professional%2C%20clean%20white%20background%2C%20modern%20professional%20headshot%2C%20friendly%20demeanor&width=300&height=300&seq=team3&orientation=squarish" 
                alt="Roberto Jiménez" 
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover object-top"
              />
              <h3 className="text-xl font-bold text-gray-800 mb-2">Roberto Jiménez</h3>
              <p className="text-green-600 font-medium mb-2">Director de Marketing</p>
              <p className="text-gray-600 text-sm">
                Especialista en marketing deportivo con amplia experiencia en el sector.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-red-600 to-red-700">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              ¿Listo para Jugar?
            </h2>
            <p className="text-xl mb-8 opacity-90">
              Únete a nuestra comunidad y encuentra la cancha perfecta para tu próximo partido
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="bg-white text-red-600 hover:bg-gray-100">
                Buscar Canchas
              </Button>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-red-600">
                Registrar mi Cancha
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
